export const VOUCHER_TYPE_OPTIONS = [
  { value: "gift_card", label: "Bon d'achat" },
  { value: "free_product", label: "Produit offert" },
  { value: "discount", label: "Réduction sur addition" },
  { value: "bogo", label: "Buy One, Get One" },
] as const;

export type VoucherType = (typeof VOUCHER_TYPE_OPTIONS)[number]["value"];
export function getVoucherTypeLabel(value: VoucherType): string {
  return VOUCHER_TYPE_OPTIONS.find((t) => t.value === value)?.label || value;
}
